"use strict";
// ============= DEV / QA ONLY ==============
// Check how many queries run on page load
if (queryCount) {
    checkQueryCount(queryCount, "the page");
}

$(document).ajaxSuccess(function(ev, xhr, settings) {
    var count = xhr.getResponseHeader("__NHibernate_QueryCount");
    checkQueryCount(count, "an ajax call.");
});

function checkQueryCount(count, source) {
    if (count > 10) {
        toastr.error("There were " + count + " queries from " + source);
    }
}
